// extracted by mini-css-extract-plugin
export default {"iframe":"GreenerWheelsModule_iframe__vLSbb"};